(() => {
  if (window.almilaProjectStudioLoaded) return;
  window.almilaProjectStudioLoaded = true;
  const selector = '.almila-project-studio';
  const instances = new Map();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function mount(root) {
    if (instances.has(root)) return;
    const video = root.querySelector('.almila-project-studio__video');
    const button = root.querySelector('.almila-project-studio__video-toggle');
    if (!video || !button) return;
    video.controls = false;
    button.hidden = false;
    // The video loads nothing (preload="none") until it is on screen; data-autoplay plays it there.
    let visible = false;
    let manuallyPaused = false;
    const updateButton = () => {
      const paused = video.paused;
      // The same drawn play/pause icons as the homepage hero (a text glyph would fall back to a system font).
      button.querySelector('[data-studio-icon="play"]')?.toggleAttribute('hidden', !paused);
      button.querySelector('[data-studio-icon="pause"]')?.toggleAttribute('hidden', paused);
      button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
    };
    const sync = () => {
      if (reducedMotion.matches || !visible || manuallyPaused) {
        video.pause();
      } else if (video.hasAttribute('data-autoplay')) {
        video.play().catch(() => {});
      }
      updateButton();
    };
    const onClick = () => {
      manuallyPaused = !video.paused;
      if (video.paused) {
        manuallyPaused = false;
        video.play().catch(() => {});
      } else video.pause();
      updateButton();
    };
    button.addEventListener('click', onClick);
    video.addEventListener('play', updateButton);
    video.addEventListener('pause', updateButton);
    reducedMotion.addEventListener('change', sync);
    const observer = new IntersectionObserver(entries => {
      visible = entries[0]?.isIntersecting ?? false;
      sync();
    }, {threshold: 0.05});
    observer.observe(root);
    sync();
    instances.set(root, () => {
      observer.disconnect();
      reducedMotion.removeEventListener('change', sync);
      button.removeEventListener('click', onClick);
      video.removeEventListener('play', updateButton);
      video.removeEventListener('pause', updateButton);
      video.pause();
    });
  }

  function within(target, callback) {
    if (target.matches?.(selector)) callback(target);
    target.querySelectorAll?.(selector).forEach(callback);
  }
  function unload(target) {
    within(target, root => {
      instances.get(root)?.();
      instances.delete(root);
    });
  }
  document.querySelectorAll(selector).forEach(mount);
  document.addEventListener('shopify:section:load', event => within(event.target, mount));
  document.addEventListener('shopify:block:load', event => within(event.target, mount));
  document.addEventListener('shopify:section:unload', event => unload(event.target));
  document.addEventListener('shopify:block:unload', event => unload(event.target));
})();
